export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Resize-Small-Gray-f59bfa7d1f41ab55836167cd500ba895.svg";